import type { FunctionComponent } from "react"

import classNames from "classnames"
import { useSearchParams } from "next/navigation"
import { useEffect } from "react"

import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { JobAdsGroupFilter } from "@/modules/companies/client/components/JobAdsGroupFilter/JobAdsGroupFilter"
import { useCompanyJobOffersSearchTrack } from "@/modules/companies/client/hooks/tracking/useCompanyJobOffersSearchTrack"
import { useJobAdsSearchHasFilter } from "@/modules/companies/client/hooks/useJobAdsSearchHasFilter"
import { ExclusiveSwitchFilter } from "@/modules/jobAds/client/components/ExclusiveSwitchFilter/ExclusiveSwitchFilter"
import { PrimaryFilters } from "@/modules/jobAds/client/components/PrimaryFilters/PrimaryFilters"
import { useJobAdsFromAlgolia } from "@/modules/jobAds/client/hooks/useJobAdsFromAlgolia"
import { urlSearchParamsToParsedUrlQuery } from "@/modules/routing/helpers/urlSearchParamsToParsedUrlQuery"
import { useCurrentUserSearchConfigFetch } from "@/modules/user/client/hooks/useCurrentUserSearchConfigFetch"

import styles from "./JobAdsFilters.module.css"
import stylesJobAdsLayout from "@/modules/jobAds/client/components/Layout/Layout.module.css"

export const JobAdsFilters: FunctionComponent = () => {
  const hasFilters = useJobAdsSearchHasFilter()
  const companyJobOffersSearchTrack = useCompanyJobOffersSearchTrack()
  const { dataJobAds, isLoadingJobAds, isErrorJobAds } = useJobAdsFromAlgolia()
  const { dataCurrentUserSearchConfig } = useCurrentUserSearchConfigFetch()
  const searchParams = useSearchParams()
  const search = searchParams.toString()

  const showJobAdsFilter = (dataJobAds && dataJobAds.jobAds.length > 0) || hasFilters

  useEffect(() => {
    if (!isLoadingJobAds && !isErrorJobAds && dataJobAds) {
      const query = urlSearchParamsToParsedUrlQuery(searchParams)
      companyJobOffersSearchTrack(query, dataJobAds.totalSize)
    }
    // searchParams changes on every render so we use its stringified output
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyJobOffersSearchTrack, dataJobAds, isErrorJobAds, isLoadingJobAds, search])

  if (!dataCurrentUserSearchConfig) return null
  if (!showJobAdsFilter) return null

  return (
    <Layout hasBottomPadding colorBlock={LAYOUT_COLOR_BLOCK.WHITE}>
      <Layout.Column>
        <PrimaryFilters className={classNames(stylesJobAdsLayout.primaryFilters, styles.companyPrimaryFilters)} />
        <div className={styles.companySecondaryFilters}>
          <ExclusiveSwitchFilter />
          <JobAdsGroupFilter />
        </div>
      </Layout.Column>
    </Layout>
  )
}
